"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useJira_1 = __importDefault(require("hooks/useJira"));
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importStar(require("components/design-system/Modal"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const HeaderModalJira = ({ closeCurrentModal, isViewChildOnCreate }) => {
    const { closeModal } = (0, Modal_1.useModal)() || {};
    const stepModal = (0, useJira_1.default)((state) => state.stepModal);
    const setStepModal = (0, useJira_1.default)((state) => state.setStepModal);
    const exitModal = () => {
        closeCurrentModal();
        closeModal && closeModal();
    };
    return (react_1.default.createElement(Modal_1.default.Header, { customClass: "px-[24px] pt-[24px] flex justify-between" },
        react_1.default.createElement("p", { className: "typography-h600 text-n-900 mb-[24px]" }, (0, HelperUtils_1.getObjectiveLocale)(stepModal == 'child-issues' ? 'Child Issues' : 'Connect Data')),
        react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-clear", size: 24, fillColor: "var(--n-600)", dataCy: "close-modal-jira", onClick: () => isViewChildOnCreate ? setStepModal('confirm') : exitModal() })));
};
exports.default = HeaderModalJira;
